module.exports = __webpack_public_path__ + "img/sld_scb_16_t1_b1_green.01c86361.svg";